<div class="footer">
    <div class="footer__top">
        <div class="footer__logo" routerLink="/home" (click)="track('footer-site-logo')">
            <img src="assets/logos/logo-screen-for-epi.svg" alt="EPI Screening Tool Logo">
        </div>
        <div class="footer__menu text--button menu-desktop">
            <a routerLink="/home" (click)="track('footer-home')">Home</a>|<a routerLink="what-is-epi"
                (click)="track('footer-what-is-epi')">What is EPI?</a>|<a routerLink="development"
                (click)="track('footer-development')">Development</a>|<a routerLink="screening-tool-landing"
                (click)="track('footer-screening-tool')">The screening tool</a>|<a routerLink="faqs"
                (click)="track('footer-faqs')">FAQs</a>
        </div>
        <div class="footer__menu-mobile">
            <a routerLink="/home" (click)="track('footer-home')">Home</a>
            <a routerLink="what-is-epi" (click)="track('footer-what-is-epi')">What is EPI?</a>
            <a routerLink="development" (click)="track('footer-development')">Development</a>
            <a routerLink="screening-tool-landing" (click)="track('footer-screening-tool')">The screening tool</a>
            <a routerLink="faqs" (click)="track('footer-faqs')">FAQs</a>
        </div>
    </div>
    <hr>
    <div class="footer__bottom">
        <div class="footer__block">
            <div class="footer__menu text--button">
                    <a href="https://www.abbvie.com/accessibility-statement.html" target="_blank"
                    (click)="track('footer-accessibility-link')">Accessibility Statement</a>|
                    <a href="https://www.abbvie.com/contactus.html" target="_blank"
                    (click)="track('footer-contactus')">Contact Us</a>|
                    <a href="https://www.abbvie.com/terms-of-use.html" target="_blank"
                    (click)="track('footer-terms-of-use')">Terms of Use</a>|<span><a href="https://privacy.abbvie/privacy-policies/us-privacy-policy.html" target="_blank"
                    (click)="track('footer-privacy-notice')">Privacy Notice</a>|<a href="javascript:void(0);" id="ot-sdk-btn"
                    class="ot-sdk-show-settings" title="Cookies Settings" (click)="track('footer-cookies-settings')">Cookies Settings</a>|<a
                    href="https://abbviemetadata.my.site.com/AbbvieDSRM/" target="_blank" class="privacy-choices-link"
                    (click)="track('footer-your-privacy-choices')">Your Privacy Choices</a><img class="newPrivacyIcon" src="assets/icons/privacy-choices-white-transparent-bg_120w.png" alt="Privacy Choices Icon"></span>
            </div>
        </div>
        <div class="footer__abbvie">
            <a href="https://www.abbvie.com" target="_blank" (click)="track('footer-abbvie-logo')">
                <img src="assets/logos/logo-abbvie.svg" alt="AbbVie Logo">
            </a>
        </div>
    </div>
    <div class="footer__copyright">
        <p>Copyright © 2023 AbbVie Inc. North Chicago, IL 60064.</p>
        <p>ABBV-US-00951-MC, V2, approved April 2023</p>
    </div>
</div>